var _path, _path2, _g, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiologicCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ikon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.815,
    height: 59.905,
    viewBox: "0 0 56.815 59.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15838",
    "data-name": "Path 15838",
    d: "M2,10V47.121a6.339,6.339,0,0,0,6.087,6.551H52.728a6.339,6.339,0,0,0,6.087-6.551V10Z",
    transform: "translate(-2 6.233)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15839",
    "data-name": "Path 15839",
    d: "M52.728,4H8.087A6.094,6.094,0,0,0,2,10.087v6.087H58.815V10.087A6.094,6.094,0,0,0,52.728,4Z",
    transform: "translate(-2 0.058)",
    fill: "#acd4f8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10584",
    "data-name": "Group 10584",
    transform: "translate(12.175 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15840",
    "data-name": "Path 15840",
    d: "M24.029,14.175A2.029,2.029,0,0,1,22,12.146V4.029a2.029,2.029,0,0,1,4.058,0v8.116A2.029,2.029,0,0,1,24.029,14.175Z",
    transform: "translate(6.408 -2)",
    fill: "#425b72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15841",
    "data-name": "Path 15841",
    d: "M10.029,14.175A2.029,2.029,0,0,1,8,12.146V4.029a2.029,2.029,0,0,1,4.058,0v8.116A2.029,2.029,0,0,1,10.029,14.175Z",
    transform: "translate(-8 -2)",
    fill: "#425b72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15842",
    "data-name": "Path 15842",
    d: "M17.029,14.175A2.029,2.029,0,0,1,15,12.146V4.029a2.029,2.029,0,1,1,4.058,0v8.116A2.029,2.029,0,0,1,17.029,14.175Z",
    transform: "translate(-0.796 -2)",
    fill: "#425b72"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15843",
    "data-name": "Path 15843",
    d: "M15.4,28.329a8.39,8.39,0,0,0,.553,2.555,1.564,1.564,0,0,0,2.788-.028,7.186,7.186,0,0,0,.553-2.491l.793-9.1a12.179,12.179,0,0,0-.4-5.638c-.605-1.436-3.281-1.409-4.237-.24-1.369,1.8-.648,3.315-.636,6.1Z",
    transform: "translate(10.977 10.594)",
    fill: "#4c36e4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15844",
    "data-name": "Path 15844",
    d: "M17.38,23.582a2.758,2.758,0,1,0,2.777,2.739A2.758,2.758,0,0,0,17.38,23.582Z",
    transform: "translate(11.009 23.3)",
    fill: "#4c36e4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiologicCalendar);
export default __webpack_public_path__ + "static/media/BiologicCalendar.a03925f369dcfa6904d7bf9902e625ed.svg";
export { ForwardRef as ReactComponent };